// const baseURL = 'http://localhost'; //for dev env
const baseURL = 'https://fklacteos.flkdevelopment.com';
export default baseURL;
